module.exports = __webpack_public_path__ + "img/5.aa7fed5c.png";